export default "__VITE_ASSET__i2VEE2eH__"